import { ArrowRight, Calendar } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"

/**
 * Call-to-action section at the bottom of the Multi-Agent Orchestration page.
 * Features a dark neutral background with subtle accents.
 */
export function CtaSection() {
  const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden bg-neutral-900 py-20 lg:py-24">
      {/* Background decoration */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-secondary/5 blur-3xl" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:40px_40px]" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-6 text-3xl font-bold text-white lg:text-4xl">
          Ready to Build Your AI Team?
        </h2>
        <p className="mx-auto mb-10 max-w-2xl text-lg text-neutral-400">
          Start with one agent and scale to hundreds. Your Lead Agent handles the
          coordination automatically, so you can focus on what matters.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button
            size="lg"
            className="group bg-primary text-white hover:bg-primary/90"
            onClick={() => navigate("/signup")}
          >
            Get Started Free
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-neutral-700 bg-transparent text-white hover:bg-neutral-800"
            onClick={() => navigate("/demo")}
          >
            <Calendar className="mr-2 h-4 w-4" />
            Book a Demo
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-sm text-neutral-500">
          <span>No credit card required</span>
          <span className="hidden sm:inline text-neutral-700">|</span>
          <span>Free tier available</span>
          <span className="hidden sm:inline text-neutral-700">|</span>
          <span>Enterprise ready</span>
        </div>
      </div>
    </section>
  )
}
